import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { loadMoreList,commonData } from "@/mixins/index";
import modifyUser from './components/modifyUser.vue';
import modifyAppList from './components/modifyAppList.vue';
export default {
  name: "enterpriseManagement",
  // mixins: [ loadMoreList,commonData ],
  components: {
    modifyUser: modifyUser,
    modifyAppList: modifyAppList
  },
  data: function data() {
    return {
      pagingReqFn: "subAdminTree",
      // delIds: [],
      treeData: [],
      // 专门用于存储树形数据的数组
      defaultProps: {
        children: "children",
        label: "nickname"
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.reqLoading = true;
                _context.prev = 1;
                _context.next = 4;
                return _this.$api[_this.pagingReqFn]();

              case 4:
                res = _context.sent;

                if (res.status === 200 && res.data) {
                  _this.treeData = [res.data];
                }

              case 6:
                _context.prev = 6;
                _this.reqLoading = false;
                return _context.finish(6);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1,, 6, 9]]);
      }))();
    },
    handleCommand: function handleCommand(command, row) {
      if (command === "editUser") {
        this.$refs.modifyUser.init(row.id);
      } else if (command === "editProduct") {
        this.$refs.modifyAppList.init(row.id);
      }
    }
  }
};